{
    "list": {
        "title": "Delivery notes",
        "columns": "Columns"
    },
    "details": {
        "title": "Delivery note",
        "document": "Delivery note document"
    },
    "columns": {
        "name": "Name",
        "vendor": "Vendor",
        "dateOfIssue": "Date",
        "createdBy": "Created by",
        "linkedTo": "Linked to",
        "action": "Action"
    },
    "drawer": {
        "editDeliveryNote": "Edit delivery note",
        "newDeliveryNote": "New delivery note",
        "newDeliveryNoteForPo": "New delivery note for purchase order #{{ poNumber }}",
        "dnNumber": "Delivery note number",
        "dateOfIssue": "Date of issue"
    },
    "states": {
        "DELIVERY_NOTE_DOCUMENT_PENDING": "Document pending",
        "DELIVERY_NOTE_DOCUMENT_SUCCESS": "Document received",
        "DELIVERY_NOTE_PARTIALLY_LINKED": "Partially linked",
        "DELIVERY_NOTE_FULLY_LINKED": "Linked",
        "DELIVERY_NOTE_DELETED": "Deleted"
    }
}
